import React, { useState } from 'react';
import { Center, HStack, Input, Circle, Pressable, useTheme } from 'native-base';
import { Z_INDEX } from '../Constants';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { messagesAPI } from '../../context/messages';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons';
import { LANGUAGES } from '../Constants';
const CreateMessageBox = _ref => {
  let {
    topicId,
    name,
    username
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;

  /**
   *  when accessing private message screen from MESSAGES or SENT tab,
   *  {name} would be 'Anthony J'
   *
   *  but when coming from ACTIVITIES tab,
   *  {name} would be 'frn_member.1407'
   *
   * this is because each activity (notification) item contains only username value
   */

  const isNewDirectMessage = !topicId ? true : false;
  const [raw, setRaw] = useState('');
  const authState = useAuthState();
  const envState = useEnvState();
  const handleSendPrivateMessage = async () => {
    try {
      let data = {};
      if (isNewDirectMessage) {
        data = {
          title: `Message with ${name}`,
          raw,
          archetype: 'private_message',
          target_recipients: username
        };
      } else {
        data = {
          raw,
          topic_id: topicId
        };
      }
      const response = await messagesAPI.sendNewMessage(envState.base_url, authState.api_key, data);
      setRaw('');
      return response;
    } catch (err) {
      console.log('Error while sending private message');
      return err;
    }
  };
  return /*#__PURE__*/React.createElement(Center, {
    position: 'absolute',
    bottom: 0,
    w: '100%',
    h: '12%',
    borderTopWidth: 1,
    borderTopColor: colors.createMessageBox.border,
    Z_INDEX: Z_INDEX.top
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 4
  }, /*#__PURE__*/React.createElement(Input, {
    w: '70%',
    placeholder: `${LANGUAGES.PLACEHOLDERS.SEND_PM} ${name}...`,
    value: raw,
    onChangeText: t => setRaw(t),
    _focus: {
      borderColor: colors.createMessageBox.border
    }
  }), /*#__PURE__*/React.createElement(Pressable, {
    justifyContent: 'center',
    alignItems: 'center',
    onPress: handleSendPrivateMessage
  }, /*#__PURE__*/React.createElement(Circle, {
    size: 10,
    bg: colors.createMessageBox.circle
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPaperPlaneTop,
    color: colors.createMessageBox.icon
  })))));
};
export default CreateMessageBox;
//# sourceMappingURL=CreateMessageBox.js.map